import { useHistory } from 'react-router-dom';
import { stringify as querify } from 'qs';

const useOpenModal = () => {
	const history = useHistory();

	return (name: string, state?: any) =>
		history.push(
			{
				search: querify({ modal: name }, { addQueryPrefix: true }),
			},
			{ ...state }
		);
};

export default useOpenModal;
